import { Box, Container, Typography, IconButton, SvgIcon } from '@mui/material';
import { Logo, Facebook as FacebookIcon, Instagram as InstagramIcon, Email as EmailIcon } from '../../icons';
import { landingColors, landingFont } from '../landingTheme';
import { NAV_ITEMS, SUPPORT_EMAIL } from '../landingContent';

function TikTokIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 0 1 15.54 3h-3.09v12.4a2.592 2.592 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6 0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64 0 3.33 2.76 5.7 5.69 5.7 3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48z" />
    </SvgIcon>
  );
}

const SOCIALS = [
  { Icon: FacebookIcon, label: 'Facebook' },
  { Icon: InstagramIcon, label: 'Instagram' },
  { Icon: TikTokIcon, label: 'TikTok' },
];

export default function FooterSection({ onScrollToSection }) {
  return (
    <Box component="footer" sx={{ backgroundColor: '#07070d', color: '#fff', py: { xs: 6, md: 8 } }}>
      <Container maxWidth="lg" sx={{ px: { xs: 2.5, md: 4 } }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '2fr 1fr 1fr' }, gap: { xs: 4, md: 6 }, mb: 5 }}>
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
              <Logo size={34} variant="white" />
              <Typography sx={{ fontFamily: landingFont, fontWeight: 800, fontSize: '1.3rem' }}>merchQRy</Typography>
            </Box>
            <Typography sx={{ fontFamily: landingFont, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, mb: 3, maxWidth: 340, fontSize: '0.92rem' }}>
              The complete QR ordering solution for modern restaurants. From scan to payment to dashboard, all covered.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.25 }}>
              {SOCIALS.map(({ Icon, label }) => (
                <IconButton
                  key={label}
                  aria-label={label}
                  sx={{
                    color: 'rgba(255,255,255,0.7)',
                    backgroundColor: 'rgba(255,255,255,0.08)',
                    '&:hover': { backgroundColor: landingColors.indigo, color: '#fff' },
                    transition: 'all 0.25s ease',
                  }}
                >
                  <Icon />
                </IconButton>
              ))}
            </Box>
          </Box>

          <Box>
            <Typography sx={{ fontFamily: landingFont, fontWeight: 700, mb: 2, fontSize: '1.05rem' }}>Product</Typography>
            {NAV_ITEMS.map((item) => (
              <Typography
                key={item.id}
                onClick={() => onScrollToSection(item.id)}
                sx={{
                  fontFamily: landingFont,
                  color: 'rgba(255,255,255,0.6)',
                  mb: 1.25,
                  cursor: 'pointer',
                  fontSize: '0.92rem',
                  '&:hover': { color: '#fff' },
                }}
              >
                {item.label}
              </Typography>
            ))}
          </Box>

          <Box>
            <Typography sx={{ fontFamily: landingFont, fontWeight: 700, mb: 2, fontSize: '1.05rem' }}>Contact</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
              <EmailIcon sx={{ fontSize: 20, color: 'rgba(255,255,255,0.5)' }} />
              <Typography sx={{ fontFamily: landingFont, color: 'rgba(255,255,255,0.6)', fontSize: '0.92rem' }}>
                {SUPPORT_EMAIL}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ pt: 4, borderTop: '1px solid rgba(255,255,255,0.1)', textAlign: 'center' }}>
          <Typography sx={{ fontFamily: landingFont, color: 'rgba(255,255,255,0.5)', fontSize: '0.88rem' }}>
            © {new Date().getFullYear()} merchQRy. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
